"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatPrice = void 0;
var _currency = require("@shopee_common/currency");
var formatPrice = function formatPrice(cid, price) {
  var formattedPrice;
  try {
    formattedPrice = (0, _currency.formatCurrency)(cid || 'SG', price); // 新地区可能暂不支持
  } catch (error) {
    formattedPrice = (0, _currency.formatCurrency)('SG', price);
  }
  return formattedPrice;
};
exports.formatPrice = formatPrice;